import { referenceDataEditRules } from '@app/pcs/administration/models';
import { operationPoint } from '@app/pcs/models';
import { gql } from 'apollo-angular';


export const fetchOperationPoints = 'operationPoints';
export const fetchOperationPointsQuery = gql`
  query FetchOperationPointsQuery ($searchContext: OperationPointSearchContextInput!){
    operationPoints (searchContext: $searchContext) {
      ...operationPoint
    }
  }
  ${operationPoint}
`;

export const fetchOperationPointsWithEditRuleQuery = gql`
  query FetchOperationPointsWithEditRuleQuery ($searchContext: OperationPointSearchContextInput!, $countries: [CountryInput]!, $userGridType: UserGridTypeInput){
    operationPoints (searchContext: $searchContext) {
      ...operationPoint
    }
    operationPointsEditRules (countries: $countries) {
      ...referenceDataEditRules
    }
    userGridConfiguration (type: $userGridType) {
      configuration
    }
  }
  ${operationPoint}
  ${referenceDataEditRules}
`;

export const validatePrimaryLocationCodeQuery = gql`
  query ValidatePrimaryLocationCode ($operationPoint: OperationPointInput!) {
    validatePrimaryLocationCode (operationPoint: $operationPoint)
  }
`;
